const model = () => {
	return {
		sku: 		'',
		desc: 		'',
		qty: 		'',
		unit_price: '',
		mod: 		''
	};
};

export default {
	model
};